import React, { useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { distributionUrl } from "../../../../Config/url";
import axios from "axios";
import { useCookies } from "react-cookie";
import { getCroppedImg } from "./_utils/canvasUtils";

const ImageCropper = ({
  image,
  imageType,
  onCropDone,
  onCropCancel,
  setCurrentPage,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);
  const [aspectRatio, setAspectRatio] = useState(4 / 3);
  const [isLoading, setIsLoading] = useState(false);
  const [cookie] = useCookies();

  const getAspectRatios = () => {
    return [
      { value: 4 / 3, label: "4:3 (Default)" },
      { value: 1 / 1, label: "1:1" },
      { value: 18 / 6, label: "18:6" },
      { value: 360 / 180, label: "2:1" },
      { value: 3 / 2, label: "Үнэмлэхний хэмжээ" },
      { value: 510 / 100, label: "Гарын үсэг хэмжээ" },
    ];
  };

  const aspectRatios = getAspectRatios();

  useEffect(() => {
    if (imageType === "passport_front" || imageType === "passport_back") {
      setAspectRatio(3 / 2);
    } else if (imageType === "signature") {
      setAspectRatio(510 / 100);
    } else {
      setAspectRatio(4 / 3);
    }
  }, [imageType]);

  const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
    setCroppedArea(croppedAreaPixels);
  };

  const onAspectRatioChange = (event) => {
    setAspectRatio(Number(event.target.value));
  };

  const onCropApply = async () => {
    if (!croppedArea) return;
    setIsLoading(true);
    try {
      const croppedImage = await getCroppedImg(image, croppedArea);

      const imgForm = new FormData();
      imgForm.append("file", croppedImage, "image.png");

      const res = await axios.post(
        distributionUrl + "media/panel/files",
        imgForm,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            Authorization: "Bearer " + cookie.mmusic_token,
            "Publisher-Id": JSON.parse(
              localStorage.getItem("Current-Publisher")
            )?.id,
          },
        }
      );

      if (res.status === 200) {
        onCropDone(res.data);
      }
    } catch (err) {
      console.error("Error uploading image", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white shadow-xl rounded-2xl overflow-hidden w-[90%] max-w-2xl">
        <div className="relative w-full h-[600px]">
          <Cropper
            image={image}
            aspect={aspectRatio}
            crop={crop}
            zoom={zoom}
            onZoomChange={setZoom}
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            style={{
              container: {
                width: "100%",
                height: "100%",
                backgroundColor: "#fff",
              },
            }}
          />
        </div>

        {/* Aspect Ratio Options */}
        <div className="flex justify-center gap-2 px-4 py-6">
          {aspectRatios.map((ratio, index) => (
            <label
              key={index}
              className="flex items-center gap-2 cursor-pointer"
            >
              <input
                type="radio"
                name="ratio"
                value={ratio.value}
                checked={ratio.value === aspectRatio} // Ensure proper checked state
                onChange={onAspectRatioChange}
              />
              <p className="text-xs">{ratio.label}</p>
            </label>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between px-4 py-2 border-t">
          <button
            className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
            onClick={onCropCancel}
          >
            Болих
          </button>
          <button
            className="px-4 py-2 bg-[#5863f1] text-white rounded-md hover:bg-[#4851d1]"
            onClick={onCropApply}
            disabled={isLoading}
          >
            {isLoading ? "Хадгалж байна..." : "Хадгалах"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageCropper;
